@if (showBanner()) {
    <div class="st-rich-text-editor__banner">
        <mat-icon>report</mat-icon>
        <div>{{ languageSettings.PSTWebBannerCollaborationSessionFull }}</div>
    </div>
}
<div
    #aboveBlackLine
    class="st-rich-text-editor__above-black-line bottom"
    [class.st-rich-text-editor__with-banner]="showBanner()"
    [froalaEditor]="options"
    [froalaModel]="contentAboveBL()"
    (froalaModelChange)="onContentChange($event, EditorPostion.ABOVE)"></div>

<div
    class="st-rich-text-editor__not-for-broadcast-watermark"
    [attr.data-content]="story()?.LegalBlock ? languageSettings.PSTEditorStoryNotToBeBroadcast : ''"></div>

<div class="st-rich-text-editor__black-line">
    <div
        class="st-rich-text-editor__black-line__arrow-controls"
        [class.circle-container]="circleContainer()">
        <div [class.circle-arrows-wrapper]="circleContainer()">
            <button
                mat-icon-button
                class="st-rich-text-editor__black-line__arrow-controls__arrow-btn"
                [class.st-rich-text-editor__black-line__arrow-controls__arrow-btn--colored]="currentPosition() === BlackLinePositionEnum.BOTTOM && hasContentBelowBL()"
                [class.st-rich-text-editor__black-line__arrow-controls__arrow-btn--hidden]="currentPosition() === BlackLinePositionEnum.TOP"
                (click)="onArrowUpClick()">
                <mat-icon fontSet="material-symbols-outlined">keyboard_arrow_up</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-rich-text-editor__black-line__arrow-controls__arrow-btn"
                [class.st-rich-text-editor__black-line__arrow-controls__arrow-btn--hidden]="currentPosition() === BlackLinePositionEnum.BOTTOM"
                (click)="onArrowDownClick()">
                <mat-icon fontSet="material-symbols-outlined">keyboard_arrow_down</mat-icon>
            </button>
        </div>
    </div>
</div>
<div
    #belowBlackLine
    class="st-rich-text-editor__bellow-black-line bottom"
    [froalaEditor]="optionsBelowBlackLine"
    [froalaModel]="contentBelowBL()"
    (froalaModelChange)="onContentChange($event, EditorPostion.BELOW)"></div>
